import React, { useState, useContext } from 'react';
import Navbar from '../Navbar/Navbar';
import Sidebar from '../SidebbarPart/Sidebar';
import { Outlet } from 'react-router-dom';
import { authContext } from '../../Context/Authentication';

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { Token } = useContext(authContext);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      
      {/* <main
        style={{
          marginTop: '70px',
marginRight: Token ? (sidebarOpen ? '280px' : '80px') : '0',
          transition: 'margin-right 0.3s ease',
          minHeight: 'calc(100vh - 70px)',
        }}
        className="main-content-wrapper"
      >
        <Outlet />
      </main> */}




      {/* <style>{`
        @media (max-width: 991.98px) {
          .main-content-wrapper {
            margin-right: 0 !important;
          }
        }
      `}</style> */}


<main
  style={{
    marginTop: '70px',
    minHeight: 'calc(100vh - 70px)',
  }}
  className={`main-content-wrapper ${Token && sidebarOpen ? 'sidebar-open' : Token ? 'sidebar-collapsed' : ''}`}
>
  <Outlet />
</main>

<style>{`
  .sidebar-open {
    margin-right: 280px;
    transition: margin-right 0.3s ease;
  }
  .sidebar-collapsed {
    margin-right: 80px;
    transition: margin-right 0.3s ease;
  }
  @media (max-width: 991.98px) {
    .sidebar-open,
    .sidebar-collapsed {
      margin-right: 0 !important;
    }
  }
`}</style>


    </>
  );
}